module.exports = __webpack_public_path__ + "static/media/CGU.f07bfc3b.pdf";